import { PromoPageContentV2 } from 'components/common/PromoPageContentV2';
import { usePromotionV2 } from 'hooks/pages/usePromotionV2';
import { useRouter } from 'next/router';

export const PromotionV2 = () => {
  const router = useRouter();
  const { slug } = router.query;
  const { data: promotion } = usePromotionV2(slug as string);

  return <PromoPageContentV2 {...promotion} />;
};
